import type { ComputedRef } from 'vue';

export enum TabVariant {
  Line = 'line',
  Enclosed = 'enclosed',
}

export type TabVariants = `${TabVariant}`;

export interface TabsInjection {
  activeTab: ComputedRef<string>;
  variant: ComputedRef<TabVariants>;
  setActiveTab: (newTabValue: string) => void;
}
